import React, { useEffect, useState, useRef, useCallback } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import CalculationToolSummary from "../../sections/calculation-tool-summary";
import ServerError from "../../sections/server-error";
import MobilePriceBanner from "./components/MobilePriceBanner";
import ToolSection from "./components/ToolSection";
import CalculationToolTabs from "./components/CalculationToolTabs";
import ImageBanner from "../../components/ImageBanner";
import LoadingSpinner from "../../elements/loading-spinner";
import api from "../../utils/api";
import { gtag } from "../../utils";
import "./style.scss";
import { MathUtils } from "../../utils";
import { calculationPrice, comparisonToolApiBody } from "../../redux/actions/becomeAMember";
import { selectUserState } from "../../selectors/application";
import { appendQuery } from "../../utils/urlHelper";
import { setDynamicBreadcrumbList } from "../../redux/actions/actions";
import PrimaryLink from "../../elements/primary-link";
import classNames from "classnames";

const CalculationTool = ({ page, match, rendering, fields, lang, setCalculationPrice, setComparisonToolApiBody, user, history, setDynamicBreadcrumbList }) => {
  const [sitecoreRoute] = useState(match.params.sitecoreRoute);
  const { tabs = [], dictionary } = fields,
    [route, setRoute] = useState(
      match.params.param_1
        ? {
            param_1: match.params.param_1,
            param_2: match.params.param_2
          }
        : {}
    ),
    path = route.param_1 || tabs[0].fields?.path?.value,
    payment_type = route.param_2,
    currentRouteTabIndex = route.param_1 ? tabs.findIndex(item => item.fields.path.value === path) : 0,
    currentLevel = tabs[currentRouteTabIndex].fields.level.fields.key.value,
    [tabMenuItems, setTabMenuItems] = useState(
      Array.isArray(tabMenuItems)
        ? tabMenuItems
        : tabs.map((item, index) => ({
            ...{
              items: []
            },
            label: null,
            path: item.fields.path.value
          }))
    ),
    [tabItems, setTabItems] = useState(
      Array.isArray(tabItems)
        ? tabItems
        : tabs.map(item => ({
            label: null,
            items: [],
            headingType: item.fields.headingType,
            headingBody: item.fields.headingBody,
            body: item.fields.body
          }))
    ),
    [mergedSummary, setMergedSummary] = useState(typeof mergedSummary === "object" ? mergedSummary : summary),
    [country, setCountry] = useState(lang.indexOf("-") > -1 ? lang.split("-")[1] : "it"),
    [currency, setCurrency] = useState("EUR"),
    [categoryIds, setCategoryIds] = useState([]),
    [paymentTypePath, setPaymentTypePath] = useState({}),
    [serverResponseStatus, setServerResponseStatus] = useState(200),
    [serverResponseErrorMsg, setServerResponseErrorMsg] = useState(null),
    [retryCount, setRetryCount] = useState(0),
    [isLoading, setIsLoading] = useState(false),
    [isGlobalLoading, setIsGlobalLoading] = useState(true),
    [priceStickyRightPosition, setPriceStickyRightPosition] = useState(150),
    dictionaryObject = {},
    loanModal = fields.loanModal;
  dictionary.forEach(item => {
    dictionaryObject[item.fields.key.value] = item.fields.phrase.value;
  });

  useEffect(() => {
    if (route.param_1) {
      if (route.param_2) window.history.pushState(null, null, `/${match.params.lang}/${match.params.sitecoreRoute.replace(/^\//, "")}/l/${route.param_1}/p/${route.param_2}`);
      else window.history.pushState(null, null, `/${match.params.lang}/${match.params.sitecoreRoute.replace(/^\//, "")}/l/${route.param_1}`);
      match.params = {
        ...match.params,
        param_1: route.param_1,
        param_2: route.param_2
      };
    }
  }, [route]);

  // engines
  let engines = [],
    currentEngine = {};

  // mileages
  let mileages = [],
    currentMileage = null;

  // paymentType
  let paymentType = [],
    currentPaymentType = {
      defaultLanguageValue: (payment_type || (country === "nl" || country === "be" ? "cash" : "loan")).toLowerCase(),
      value: null
    };

  // duration
  let duration = [],
    currentPeriod = null;

  // downPayment
  let downPayments = [],
    currentDownPayment = null;

  // finalPayment
  let finalPayments = [],
    currentFinalPayment = null;

  // loanProduct
  let loanProducts = [],
    currentloanProduct = null;

  let spuIds,
    currentCategoryIds,
    currentSpuid = null,
    categoryIdsLocal = [],
    currcntModel = null,
    level2Data = [],
    showsDownPayment = null,
    levelOneMileage = null,
    levelOneDuration = null,
    depositPrice = 0,
    summaryPrice = 0,
    skuAttributeListValue = null,
    currentColor = {
      value: "black",
      price: 0
    };

  let summary = {
    heading: {
      type: fields.headingType,
      html: fields.headingBody,
      typographyClass: "type-h1"
    },
    features: {
      items: []
    },
    includedFeatures: {
      main: {
        label: null
      },
      items: []
    },
    info: {
      html: null
    },
    legal: {
      html: ""
    },
    price: {
      tag: fields.priceLabel.value
    },
    priceLabel: null
  };

  let validations = [];
  //Set image banner
  let imageBanner = null;
  tabs.forEach(item => {
    if (currentLevel && item.fields.level.fields.key.value === currentLevel) {
      imageBanner = item.fields.imageBanner ? item.fields.imageBanner : null;
      item?.fields?.tabs &&
        item.fields.tabs.forEach(item1 => {
          if (item1?.fields?.level?.fields?.key?.value?.toLowerCase() === currentPaymentType.defaultLanguageValue.toLowerCase()) {
            imageBanner = item1.fields.imageBanner ? item1.fields.imageBanner : null;
          }
        });
    }
  });

  const getDifPrice = (value, price) => {
    if (!value && !price) return "";
    let difprice = value - price;
    let difpriceAbs = MathUtils.priceFormatSpecial(Math.abs(difprice), lang, currentPaymentType.defaultLanguageValue.toLowerCase() === "loan");
    return `${difprice > 0 ? "-" : "+"} ${difpriceAbs}`;
  };
  const getData = async () => {
    if (!categoryIdsLocal.length && !categoryIds.length) {
      categoryIdsLocal = await getSpuidList();
      setCategoryIds(categoryIdsLocal);
    }
    let categoryIdsAll = [...categoryIdsLocal, ...categoryIds];
    setTabMenuItems(
      tabs.map(item => ({
        ...{
          items: tabItems
        },
        label: categoryIdsAll.filter(x => x.membershipCode === item.fields.level.fields?.phrase?.value)[0]?.membershipName || "level",
        path: item.fields.path.value,
        onTabClicked: (event, tab) => {
          setRoute({ param_1: tab.path });
        }
      }))
    );
    let categoryIdArr = categoryIdsAll.filter(item => {
      return tabs[currentRouteTabIndex] ? tabs[currentRouteTabIndex].fields.level.fields.phrase.value.toLowerCase() === item.membershipCode.toLowerCase() : undefined;
    });
    if (categoryIdArr.length && categoryIdArr[0].spuList.length) {
      let res = categoryIdArr[0].spuList[0];
      spuIds = res.skuIdsList;
      currentSpuid = res.id ? Number(res.id) : currentSpuid;
      currentCategoryIds = Number(categoryIdArr[0].categoryId);
      currcntModel = res.productName ? res.productName : currcntModel;
      getSpuOption(res);
    }
    for (var i = 0; i < engines.length; i++) {
      let item = engines[i];
      let carSkuid = await getSkuIdByConfigs(item.value);
      if (carSkuid) {
        let obj = await getSkuPriceBySkuid(carSkuid);
        item.price = obj.msrp;
        item.preorderdeposit = obj.price;
        if (item.defaultLanguageValue === currentEngine.defaultLanguageValue) {
          depositPrice = item.preorderdeposit;
          currentEngine.price = item.price;
        }
      }
    }
    if (currentLevel === "MEMBERSHIP02") {
      getLevel1Data();
    }
    if (currentLevel === "MEMBERSHIP03") {
      getLevel2Data();
    }
    if (currentLevel === "MEMBERSHIP04") {
      getLevel3Data();
    }
  };
  const carTypeOptionClickCallback = options => {
    gtag('event', 'Component_info', {
      'component_name': 'CalculationTool',
      'page_title': page?.name
    });
    currentEngine = engines.filter(x => x.value === options.value)[0];
    if (currentLevel === "MEMBERSHIP04") {
      getLevel3Data();
    } else {
      calculationPrice();
    }
  };
  const mileageOptionClickCallback = options => {
    gtag('event', 'Component_info', {
      'component_name': 'CalculationTool',
      'page_title': page?.name
    });
    currentMileage = {
      value: options.value,
      monthFee: 0
    };

    calculationPrice();
  };
  const durationOptionClickCallback = options => {
    gtag('event', 'Component_info', {
      'component_name': 'CalculationTool',
      'page_title': page?.name
    });
    currentPeriod = {
      value: options.value,
      monthFee: 0
    };
    if (validations.length) {
      let currentValidations = validations.filter(x => x.period === Number(options.value))[0];
      downPayments = [currentValidations.minDownPayment, currentValidations.maxDownPayment];
      if (!currentValidations.maxDownPayment) {
        currentDownPayment = 0;
      }
      finalPayments = [currentValidations.minFinalPayment, currentValidations.maxFinalPayment];
      if (!currentValidations.maxFinalPayment) {
        currentFinalPayment = 0;
      }
    }
    calculationPrice();
  };
  const downpaymentSiderCallBack = value => {
    currentDownPayment = Number(value);
    calculationPrice();
  };
  const finalpaymentSiderCallBack = value => {
    currentFinalPayment = Number(value);
    calculationPrice();
  };
  const loanProductOptionClickCallback = options => {
    let selectItem = loanProducts.filter(x => x.value === options.value);

    if (selectItem && selectItem.length) {
      currentloanProduct = selectItem[0];

      validations = currentloanProduct.validations;
      let defaultSimulation = currentloanProduct.defaultSimulation;
      currentPeriod = {
        value: defaultSimulation.period,
        monthFee: 0
      };
      currentDownPayment = (defaultSimulation.downPayment * currentEngine.price) / 100;
      currentFinalPayment = (defaultSimulation.finalPayment * currentEngine.price) / 100;
      let currentValidations = validations.filter(x => x.period === Number(currentPeriod.value))[0];
      duration = [];
      mileages = [];
      validations.forEach(x => {
        duration.push({
          value: x.period,
          monthFee: 0
        });
        x &&
          x.auto &&
          x.auto.estimatedAnnualMileage &&
          x.auto.estimatedAnnualMileage.models &&
          x.auto.estimatedAnnualMileage.models[0] &&
          x.auto.estimatedAnnualMileage.models[0].numUnits &&
          x.auto.estimatedAnnualMileage.models[0].numUnits.forEach(e => {
            let mIndex = mileages.findIndex(fx => fx.value === e);
            if (mIndex < 0) {
              mileages.push({
                value: e,
                monthFee: 0
              });
            }
          });
      });

      downPayments = [currentValidations.minDownPayment, currentValidations.maxDownPayment];
      finalPayments = [currentValidations.minFinalPayment, currentValidations.maxFinalPayment];

      calculationPrice();
    }
  };
  const joinSummeryLabelValue = (value, type) => {
    switch (type) {
      case "currency":
        return MathUtils.priceFormatSpecial(value, lang, currentPaymentType.defaultLanguageValue.toLowerCase() === "loan");
      case "percentage":
        return MathUtils.percentFormat(value, lang);
      // case "[integer]":
      //   value = value;
      //   break;
      // case "[string]":
      //   value = value;
      //   break;
      default:
        return value;
    }
  };
  const setSummeryFields = (summeryItem, summeryData) => {
    let summeryLabels = summeryItem?.fields.labels,
      summeryFields = [];
    let summaryPriceValue = summeryItem?.fields.price.value || MathUtils.priceFormatSpecial(summaryPrice, lang, currentPaymentType.defaultLanguageValue.toLowerCase() === "loan");

    if (currentLevel === "MEMBERSHIP04" && currentPaymentType.defaultLanguageValue.toLowerCase() === "loan") {
      summary.features.items =
        summeryData &&
        summeryData.map(item => ({
          value: joinSummeryLabelValue(item.label?.value, item?.type),
          label: item.label?.local
        }));

      // footnote
      if (summeryItem.fields?.showFootnote?.value) {
        let index = summeryData.findIndex(x => x.source === "$.quotes[0].paymentsSchedule.summaryPayments[?(@.typeInstalment === 'recurrentPayment')].payment");
        if (index !== -1) {
          summary.features.items[index].footnote = summeryItem.fields?.footnoteSymbol?.value;
        }
      }

      // specail for IT
      if (lang === "it-it") {
        let data = summeryData.find(x => x.source === "$.quotes[0].interestRates[?(@.typeInterestRate === 'EffectiveInterest')].value");

        if (data?.label?.local && data?.label?.value) {
          summary.italianDiscalimerPrice = ` ${data?.label?.local} ${data?.label?.value}%`;
        } else {
          summary.italianDiscalimerPrice = "";
        }
      }
    } else {
      summeryFields = summeryLabels?.map(item => {
        let key = item.fields.value && item.fields.value.fields.key.value;
        if (key === "monthlyfree") {
          return {
            value: `${item.fields.prefixOfValue.value}${summaryPriceValue}${item.fields.suffixOfValue.value}`,
            label: item.fields.text.value
          };
        }
        if (key === "price") {
          return {
            value: `${item.fields.prefixOfValue.value}${MathUtils.priceFormatSpecial(currentEngine.price, lang, currentPaymentType.defaultLanguageValue.toLowerCase() === "loan")}${item.fields.suffixOfValue.value}`,
            label: item.fields.text.value
          };
        }
        if (key === "preorderdeposit") {
          return {
            value: `${item.fields.prefixOfValue.value}${MathUtils.priceFormatSpecial(depositPrice, lang, currentPaymentType.defaultLanguageValue.toLowerCase() === "loan")}${item.fields.suffixOfValue.value}`,
            label: item.fields.text.value
          };
        }
      });
      summary.features.items = summeryFields;
      summary.legal.html = summeryItem?.fields.legalText.value;
    }
    summary.legal.image = summeryItem?.fields.legalImage.value;
    summary.info.html = summeryItem?.fields.infoBody.value;
    summary.includedFeatures.main.label = summeryItem?.fields.included.value;
    summary.includedFeatures.items = summeryItem?.fields.includedFeatures.map(y => ({
      label: y.fields.label.value,
      icon: y.fields.icon && {
        icon: y.fields.icon.value
      },
      value: y.fields.value.value
    }));
    summary.priceLabel = `${summeryItem?.fields.prefix.value}${summaryPriceValue}${summeryItem?.fields.suffix.value}`;
    summary.priceBase = summeryItem?.fields.price.value || summaryPrice;
    summary.showInSameFontSize = summeryItem?.fields.showInSameFontSize;
    summary.showFootnote = summeryItem?.fields.showFootnote;
    summary.footnoteSymbol = summeryItem?.fields.footnoteSymbol;
    summary.showYourPrice = summeryItem?.fields.showYourPrice;
    summary.cta = { ...summeryItem?.fields.cta?.fields };
    summary.price = {
      ...summary.price,
      cta: {
        ...fields?.cta?.fields,
        ...summeryItem?.fields?.cta?.fields,
        callback: () => {
          let skuAttributeValueMap = {};
          // let summaryLink = summary?.price?.cta?.link?.value?.href;
          skuAttributeListValue.forEach(item => {
            let defaultLanguageLabelValue = item.defaultLanguageLabel ? item.defaultLanguageLabel.toLowerCase() : "";
            switch (defaultLanguageLabelValue) {
              case "engine":
                skuAttributeValueMap[item.lable] = currentEngine;
                break;
              case "finance":
                skuAttributeValueMap[item.lable] = item.spuSkuAttibuteValueList.filter(skuItem => {
                  return skuItem.defaultLanguageValue === currentPaymentType.defaultLanguageValue;
                })[0];
                break;
              case "color":
                skuAttributeValueMap[item.lable] = item.spuSkuAttibuteValueList.filter(skuItem => {
                  return skuItem.defaultLanguageValue.toLowerCase() === currentColor.defaultLanguageValue.toLowerCase();
                })[0];
                break;
              default:
                return;
            }
          });
          let calculationPriceVal = {
            membership: tabs[currentRouteTabIndex].fields.level.fields.phrase.value.toLowerCase(),
            price: summary.priceBase
          };
          creatingClues().then(() => {
            let paramsKey = {};
            for (let i in skuAttributeValueMap) {
              if (skuAttributeValueMap[i]?.value) {
                paramsKey[i.toLowerCase()] = skuAttributeValueMap[i].value;
              }
            }
            let summaryLink = summary?.price?.cta?.link?.value?.href ? `${appendQuery(summary?.price?.cta?.link?.value?.href, paramsKey)}#${calculationPriceVal?.membership?.toUpperCase()}` : `/${lang}`;
            setCalculationPrice(calculationPriceVal);
            history.replace(summaryLink);
          });
        }
      }
    };
  };
  const calculationPrice = () => {
    if (currentLevel === "MEMBERSHIP02") {
      calculationPriceLevel1();
    }
    if (currentLevel === "MEMBERSHIP03") {
      calculationPriceLevel2();
    }
    if (currentLevel === "MEMBERSHIP04") {
      calculationPriceLevel3();
    }
  };
  const calculationPriceLevel1 = () => {
    let updateItem = tabs.filter(item => item.fields.level.fields.phrase.value === "MEMBERSHIP02")[0];
    summaryPrice = currentEngine.price;
    setSummeryFields(updateItem.fields.summery);

    setTabItems(
      tabs.map((item, index) => {
        if (item.fields.level.fields.phrase.value === "MEMBERSHIP02") {
          return {
            ...{
              items: [
                {
                  label: dictionaryObject["car-heading"],
                  type: "select",
                  defaultOption: {
                    value: `${currentEngine.value}`,
                    description: dictionaryObject["included"]
                  },
                  onClick: carTypeOptionClickCallback,
                  options: engines.map(car => ({
                    value: `${car.value}`,
                    description: currentEngine.value === car.value ? dictionaryObject["included"] : getDifPrice(currentEngine.price, car.price)
                  }))
                },
                {
                  label: dictionaryObject["mileage-heading"],
                  type: "fixed",
                  value: levelOneMileage
                },
                {
                  label: dictionaryObject["duration-heading"],
                  type: "fixed",
                  value: levelOneDuration
                },
                {
                  label: dictionaryObject["downpayment-heading"],
                  type: "fixed",
                  value: MathUtils.priceFormatSpecial(Math.abs(showsDownPayment), lang, currentPaymentType.defaultLanguageValue.toLowerCase() === "loan")
                }
              ]
            },
            headingType: item.fields.headingType,
            headingBody: item.fields.headingBody,
            body: item.fields.body
          };
        }
        return {
          headingType: item.fields.headingType,
          headingBody: item.fields.headingBody,
          body: item.fields.body
        };
      })
    );
    setMergedSummary({
      ...summary,
      price: {
        ...summary.price,
        value: summary.priceLabel
      }
    });
    setIsGlobalLoading(false);
  };
  const calculationPriceLevel2 = () => {
    let levelData = {},
      pricings = {};

    level2Data.forEach(item => {
      var options = item.car.options;
      if (currentColor.defaultLanguageValue?.toLowerCase() === options[1].name?.toLowerCase() && currentEngine.defaultLanguageValue === options[0].name) {
        item.pricings &&
          item.pricings.forEach(pric => {
            let mIndex = mileages.findIndex(fx => fx.value === pric.mileage);
            if (mIndex < 0) {
              mileages.push({
                value: pric.mileage,
                monthFee: pric.monthFee
              });
            }
            let dIndex = duration.findIndex(fx => fx.value === pric.termInMonths);
            if (dIndex < 0) {
              duration.push({
                value: pric.termInMonths,
                monthFee: pric.monthFee
              });
            }
          });
        pricings = item.pricings;
        levelData = item;
        setCurrency(levelData.currency);
      }
    });
    currentMileage = (typeof mileages.filter === "function" && mileages.filter(x => x.value === (currentMileage && currentMileage.value))[0]) || mileages[0];
    currentPeriod = (typeof duration.filter === "function" && duration.filter(x => x.value === (currentPeriod && Number(currentPeriod.value)))[0]) || duration[0];
    summaryPrice = typeof pricings.filter === "function" && pricings.filter(pic => pic.mileage === currentMileage.value && pic.termInMonths === currentPeriod.value)[0].monthFee;
    let updateItem = typeof tabs.filter === "function" && tabs.filter(item => item.fields.level.fields.phrase.value === "MEMBERSHIP03")[0];

    setSummeryFields(updateItem.fields.summery);

    setTabItems(
      tabs.map((item, index) => {
        if (item.fields.level.fields.phrase.value === "MEMBERSHIP03") {
          return {
            ...{
              items: [
                {
                  label: dictionaryObject["car-heading"],
                  type: "select",
                  defaultOption: {
                    value: `${currentEngine.value}`,
                    description: dictionaryObject["included"]
                  },
                  onClick: carTypeOptionClickCallback,
                  options: engines.map(car => ({
                    value: `${car.value}`,
                    description: currentEngine.value === car.value ? dictionaryObject["included"] : getDifPrice(currentEngine.price, car.price)
                  }))
                },
                {
                  label: dictionaryObject["mileage-heading"],
                  type: "select",
                  unit: dictionaryObject["mileage-unit"],
                  description: dictionaryObject["mileage-description"],
                  defaultOption: {
                    value: `${currentMileage?.value}`,
                    description: dictionaryObject["included"]
                  },
                  onClick: mileageOptionClickCallback,
                  options: mileages.map(milg => ({
                    value: `` + milg.value,
                    description: currentMileage.value === milg.value ? dictionaryObject["included"] : getDifPrice(currentMileage.monthFee, milg.monthFee)
                  }))
                },
                {
                  label: dictionaryObject["duration-heading"],
                  type: "select",
                  unit: dictionaryObject["duration-unit"],
                  description: dictionaryObject["duration-description"],
                  onClick: durationOptionClickCallback,
                  defaultOption: {
                    value: `${currentPeriod?.value}`,
                    description: dictionaryObject["included"]
                  },
                  options: duration.map(dur => ({
                    value: `` + dur.value,
                    description: currentPeriod.value === dur.value ? dictionaryObject["included"] : getDifPrice(currentPeriod.monthFee, dur.monthFee)
                  }))
                }
              ]
            },
            headingType: item.fields.headingType,
            headingBody: item.fields.headingBody,
            body: item.fields.body
          };
        }
        return {
          headingType: item.fields.headingType,
          headingBody: item.fields.headingBody,
          body: item.fields.body
        };
      })
    );
    setMergedSummary({
      ...summary,
      price: {
        ...summary.price,
        value: summary.priceLabel
      }
    });
    setIsGlobalLoading(false);
  };
  const calculationPriceLevel3 = () => {
    let updateItem = tabs.filter(item => item.fields.level.fields.phrase.value === "MEMBERSHIP04")[0];
    let loanPaymentType = updateItem.fields.tabs?.filter(x => x.fields.path.value === "loan")[0];

    if (currentPaymentType.defaultLanguageValue.toLowerCase() === "loan" && loanPaymentType) {
      api.calculation
        .multisimulation(null, {
          countryCode: country.toUpperCase(),
          quotes: [
            {
              productId: currentloanProduct.id,
              downPayment: Number(currentDownPayment),
              loanType: currentloanProduct?.loanType,
              finalPayment: Number(currentFinalPayment),
              number: Number(currentPeriod.value),
              retailPrice: Number(currentEngine.price),
              engine: currentEngine.defaultLanguageValue,
              model: currcntModel,
              defaultRate: currentloanProduct?.defaultRate
            }
          ]
        })
        .then(res => {
          if (res.status === 200) {
            setServerResponseErrorMsg("");
            let currentQuote = {};
            res.data.quotes &&
              res.data.quotes.forEach(f => {
                if (f.period.number === Number(currentPeriod.value)) {
                  currentQuote = f;
                  let currentPaymentsSchedule = currentQuote.paymentsSchedule.summaryPayments.filter(x => x.typeInstalment === "recurrentPayment")[0];
                  summaryPrice = currentPaymentsSchedule && currentPaymentsSchedule.payment;
                }
              });

            setSummeryFields(loanPaymentType.fields.summery, currentQuote.summery);
            summary.legal.html = decodeURI(currentQuote.auto && currentQuote.auto.documentation["terms&Conditions"]);
            setTabItems(
              tabs.map((item, index) => {
                if (item.fields.level.fields.phrase.value === "MEMBERSHIP04") {
                  let loanOptions = [];
                  //carType
                  if (currentEngine) {
                    loanOptions.push({
                      label: dictionaryObject["car-heading"],
                      type: "select",
                      defaultOption: {
                        value: `${currentEngine.value}`,
                        description: dictionaryObject["included"]
                      },
                      onClick: carTypeOptionClickCallback,
                      options: engines.map(car => ({
                        value: `${car.value}`,
                        description: currentEngine.value === car.value ? dictionaryObject["included"] : getDifPrice(currentEngine.price, car.price)
                      }))
                    });
                  }
                  //loan products
                  if (loanProducts && loanProducts.length) {
                    loanOptions.push({
                      label: dictionaryObject["loan-product-heading"],
                      type: "select",
                      infoIcon: loanModal !== null,
                      infoModal: loanModal
                        ? {
                            fields: {
                              headingBody: loanModal.fields.headingBody,
                              headingType: loanModal.fields.headingType,
                              icon: {
                                svg: loanModal.fields.icon
                              },
                              body: loanModal.fields.body
                            }
                          }
                        : null,
                      description: currentloanProduct.desc,
                      defaultOption: {
                        value: `${currentloanProduct.value}`,
                        description: dictionaryObject["included"]
                      },
                      onClick: loanProductOptionClickCallback,
                      options: loanProducts.map(loanPro => ({
                        value: `${loanPro.value}`,
                        description: currentloanProduct.id === loanPro.id ? dictionaryObject["included"] : ""
                      }))
                    });
                  }
                  //mileages
                  if (mileages && mileages.length > 0) {
                    loanOptions.push({
                      label: dictionaryObject["mileage-heading"],
                      type: "select",
                      defaultOption: {
                        value: `${currentMileage.value}`,
                        description: dictionaryObject["included"]
                      },
                      onClick: mileageOptionClickCallback,
                      options: mileages.map(milg => ({
                        value: `` + milg.value,
                        description: currentMileage.value === milg.value ? dictionaryObject["included"] : getDifPrice(currentMileage.monthFee, milg.monthFee)
                      }))
                    });
                  }
                  //duration
                  if (duration && duration.length > 0) {
                    loanOptions.push({
                      label: dictionaryObject["duration-heading"],
                      type: "select",
                      defaultOption: {
                        value: `${currentPeriod.value}`,
                        description: dictionaryObject["included"]
                      },
                      onClick: durationOptionClickCallback,
                      options: duration.map(milg => ({
                        value: `` + milg.value,
                        description: Number(currentPeriod.value) === Number(milg.value) ? dictionaryObject["included"] : getDifPrice(currentPeriod.monthFee, milg.monthFee)
                      }))
                    });
                  }
                  //Downpayment
                  if (downPayments && downPayments.length > 0 && downPayments[1]) {
                    loanOptions.push({
                      label: dictionaryObject["downpayment-heading"],
                      type: "slider",
                      settings: {
                        min: downPayments[0],
                        max: downPayments[1],
                        step: 100,
                        unitIsafter: country === "se",
                        defaultValue: currentDownPayment,
                        unit: dictionaryObject["currency-symbol"],
                        callback: downpaymentSiderCallBack
                      }
                    });
                  }
                  //finalPayments
                  if (finalPayments && finalPayments.length > 0 && finalPayments[1]) {
                    loanOptions.push({
                      label: dictionaryObject["finalpayment-heading"],
                      type: "slider",
                      settings: {
                        min: finalPayments[0],
                        max: finalPayments[1],
                        step: 100,
                        unitIsafter: country === "se",
                        defaultValue: currentFinalPayment,
                        unit: dictionaryObject["currency-symbol"],
                        callback: finalpaymentSiderCallBack
                      }
                    });
                  }
                  return {
                    ...{
                      items: [
                        {
                          type: "tabs",
                          defaultLabel: currentPaymentType.defaultLanguageValue,
                          options: paymentType.map(x => ({
                            value: x.label,
                            label: x.value,
                            items: x.defaultLanguageValue.toUpperCase() === "LOAN" ? loanOptions : null
                          }))
                        }
                      ]
                    },
                    headingType: item.fields.headingType,
                    headingBody: item.fields.headingBody,
                    body: item.fields.body
                  };
                }
                return {
                  headingType: item.fields.headingType,
                  headingBody: item.fields.headingBody,
                  body: item.fields.body
                };
              })
            );
            setMergedSummary({
              ...summary,
              price: {
                ...summary.price,
                value: summary.priceLabel
              }
            });
          } else if (res.status === 400) {
            if (res.data.moreInformation) {
              setServerResponseStatus(res.status);
            } else if (res.data.quotes[0]?.errors) {
              setServerResponseErrorMsg(res.data.quotes[0]?.errors[0]?.businessMessage || res.data.quotes[0]?.errors[0]?.message);
            }
          } else {
            setServerResponseStatus(res.status);
          }
        })
        .catch(err => {
          setServerResponseStatus(500);
        })
        .finally(() => {
          setIsLoading(false);
          setIsGlobalLoading(false);
        });
    } else if (currentPaymentType.defaultLanguageValue.toLowerCase() === "cash") {
      let updateItem = tabs.filter(item => item.fields.level.fields.phrase.value === "MEMBERSHIP04")[0];
      summaryPrice = currentEngine.price;
      setSummeryFields(updateItem.fields.tabs?.filter(x => x.fields.path.value === "cash")[0].fields.summery);
      setTabItems(
        tabs.map((item, index) => {
          if (item.fields.level.fields.phrase.value === "MEMBERSHIP04") {
            let tabOptions = [];
            tabOptions.push({
              label: dictionaryObject["car-heading"],
              type: "select",
              defaultOption: {
                value: `${currentEngine.value}`,
                description: dictionaryObject["included"]
              },
              onClick: carTypeOptionClickCallback,
              options: engines.map(car => ({
                value: `${car.value}`,
                description: currentEngine.value === car.value ? dictionaryObject["included"] : getDifPrice(currentEngine.price, car.price)
              }))
            });
            tabOptions.push({
              label: dictionaryObject["downpayment-heading"],
              type: "fixed",
              value: MathUtils.priceFormatSpecial(Math.abs(showsDownPayment), lang, currentPaymentType.defaultLanguageValue.toLowerCase() === "loan")
            });
            return {
              ...{
                items: [
                  {
                    type: "tabs",
                    defaultLabel: currentPaymentType.defaultLanguageValue,
                    options: paymentType.map(x => ({
                      value: x.label,
                      label: x.value,
                      items: x.defaultLanguageValue.toUpperCase() === "CASH" ? tabOptions : null
                    }))
                  }
                ]
              },
              headingType: item.fields.headingType,
              headingBody: item.fields.headingBody,
              body: item.fields.body
            };
          }
          return {
            headingType: item.fields.headingType,
            headingBody: item.fields.headingBody,
            body: item.fields.body
          };
        })
      );
      setMergedSummary({
        ...summary,
        price: {
          ...summary.price,
          value: summary.priceLabel
        }
      });
      setIsGlobalLoading(false);
    }
  };
  const getLevel1Data = () => {
    setIsLoading(false);
    calculationPriceLevel1();
  };
  const getLevel2Data = () => {
    api.ald.products({ country }).then(res => {
      //to see the ServerError section comment the next 3 lines
      setIsLoading(false);
      setServerResponseStatus(res.status);
      if (res.status === 200) {
        level2Data = res.data;
        calculationPriceLevel2();
      }
    });
  };
  const getLevel3Data = async () => {
    let updateItem = tabs.filter(item => item.fields.level.fields.phrase.value === "MEMBERSHIP04")[0];
    let loanPaymentType = updateItem?.fields?.tabs && updateItem.fields.tabs.filter(x => x.fields.path.value === "loan")[0];
    if (currentPaymentType.defaultLanguageValue.toLowerCase() === "loan" && loanPaymentType) {
      api.calculation
        .getProducts({
          type: "LOAN",
          countryCode: country.toUpperCase(),
          productId: currentEngine.defaultLanguageValue,
          productPrice: currentEngine.price
        })
        .then(res => {
          if (res.status === 200) {
            setServerResponseErrorMsg("");
            duration = [];
            mileages = [];
            currentloanProduct = null;
            if (res && res.data) {
              let products = [];
              res.data.products &&
                res.data.products.forEach((item, xindex) => {
                  let productItem = {
                    id: item.productId,
                    value: item.productTypeDesc,
                    desc: decodeURI(item.productTypeInfo),
                    loanType: item.loanType,
                    defaultRate: item.defaultRate,
                    validations: item.validations,
                    defaultSimulation: item.defaultSimulation
                  };

                  if (xindex === 0 && !currentloanProduct) {
                    // setCurrentloanProductId(item.productId);
                    currentloanProduct = productItem;
                  }
                  if (currentloanProduct.id === item.productId) {
                    let defaultSimulation = item.defaultSimulation;
                    currentPeriod = {
                      value: defaultSimulation.period,
                      monthFee: 0
                    };
                    currentDownPayment = (defaultSimulation.downPayment * currentEngine.price) / 100;
                    currentFinalPayment = (defaultSimulation.finalPayment * currentEngine.price) / 100;
                    validations = item.validations;
                    item.validations &&
                      item.validations.forEach((element, index) => {
                        let dIndex = duration.findIndex(fx => fx.value === element.period);
                        if (dIndex < 0) {
                          duration.push({
                            value: element.period,
                            monthFee: 0
                          });
                        }

                        if (element.period === Number(currentPeriod.value)) {
                          downPayments = [element.minDownPayment, element.maxDownPayment];
                          finalPayments = [element.minFinalPayment, element.maxFinalPayment];
                        }
                        element &&
                          element.auto &&
                          element.auto.estimatedAnnualMileage &&
                          element.auto.estimatedAnnualMileage.models &&
                          element.auto.estimatedAnnualMileage.models[0] &&
                          element.auto.estimatedAnnualMileage.models[0].numUnits &&
                          element.auto.estimatedAnnualMileage.models[0].numUnits.forEach(e => {
                            let mIndex = mileages.findIndex(fx => fx.value === e);
                            if (mIndex < 0) {
                              mileages.push({
                                value: e,
                                monthFee: 0
                              });
                            }
                          });
                      });
                  }
                  products.push(productItem);
                });

              loanProducts = products;
              calculationPriceLevel3();
            }
          } else {
            setServerResponseStatus(res.status);
          }
        });
    } else if (currentPaymentType.defaultLanguageValue.toLowerCase() === "cash") {
      calculationPriceLevel3();
    }
  };
  const getPaymentTypeData = () => {
    // currentPaymentType &&
    //   setPaymentTypeOptions(currentPaymentType, carToolOptionId);
  };

  const getSpuidList = async () => {
    let data = await api.memebership.list();
    return data.obj;
  };
  const getSkuListbySpuid = async body => {
    !isLoading && setIsLoading(true);
    var res = await api.product.detail(null, body);
    if (res) {
      if (!res.obj) return;
      if (!body.hasOwnProperty("skuAttributeValueMap")) {
        getSpuOption(res.obj);
      } else {
        return res;
      }
    }
  };
  const getSpuOption = options => {
    skuAttributeListValue = options.skuAttributeList ? options.skuAttributeList : [];
    skuAttributeListValue.forEach(item => {
      let defaultLanguageLabelValue = item.defaultLanguageLabel ? item.defaultLanguageLabel.toLowerCase() : "";
      switch (defaultLanguageLabelValue) {
        case "engine":
          engines = item.spuSkuAttibuteValueList.map(listitem => ({
            defaultLanguageValue: listitem.defaultLanguageValue,
            value: listitem.value,
            price: 0
          }));
          //default car
          currentEngine = engines[0];
          break;
        case "finance":
          paymentType = item.spuSkuAttibuteValueList.map(listitem => {
            return {
              defaultLanguageValue: listitem.defaultLanguageValue,
              label: listitem.value,
              value: listitem.value
            };
          });

          currentPaymentType = paymentType.filter(x => x.defaultLanguageValue.toLowerCase() === currentPaymentType.defaultLanguageValue)[0];
          let pathArr = item.spuSkuAttibuteValueList.map(listitem => {
            return listitem.defaultLanguageValue.toLowerCase();
          });
          setPaymentTypePath(pathArr);
          break;
        case "color":
          currentColor = item.spuSkuAttibuteValueList.map(listitem => {
            return {
              defaultLanguageValue: listitem.defaultLanguageValue,
              label: listitem.value,
              value: listitem.value,
              price: 0
            };
          })[0];
          break;
        case "mileage":
          levelOneMileage = item.spuSkuAttibuteValueList[0].value;
          break;
        case "duration":
          levelOneDuration = item.spuSkuAttibuteValueList[0].value;
          break;
        case "downpayment":
          showsDownPayment = Number(item.spuSkuAttibuteValueList[0].value);
          currentDownPayment = item.spuSkuAttibuteValueList[0].value;
          break;
        default:
      }
    });

    let modelAttrbute = options.ecomerceSpuAttributeList && options.ecomerceSpuAttributeList.filter(x => x.defaultLanguageLabel === "Model");
    if (modelAttrbute && modelAttrbute.length > 0) {
      currcntModel = modelAttrbute[0].defaultLanguageValue;
    }
  };
  const getSkuIdByConfigs = async car => {
    let skuAttributeValueMap = {};
    skuAttributeListValue.forEach(item => {
      let defaultLanguageLabelValue = item.defaultLanguageLabel ? item.defaultLanguageLabel.toLowerCase() : "";
      switch (defaultLanguageLabelValue) {
        case "engine":
          skuAttributeValueMap[item.lable] = car;
          break;
        case "finance":
          skuAttributeValueMap[item.lable] = currentPaymentType.value;
          break;
        case "color":
          skuAttributeValueMap[item.lable] = currentColor.value;
          break;
        case "mileage":
          skuAttributeValueMap[item.lable] = levelOneMileage;
          break;
        case "duration":
          skuAttributeValueMap[item.lable] = levelOneDuration;
          break;
        case "downpayment":
          skuAttributeValueMap[item.lable] = currentDownPayment;
          break;
        default:
      }
    });
    let result = await getSkuListbySpuid({
      ...{ spuId: currentSpuid },
      skuAttributeValueMap
    });
    if (result.obj.skuIdsList && result.obj.skuIdsList.length) {
      return result.obj.skuIdsList[0];
    }
  };
  const getSkuPriceBySkuid = async val => {
    let skuIdval = val ? val.toString() : "";
    let data = await api.product.sku.get(
      {
        skuId: skuIdval
      },
      null
    );
    currentPaymentType.defaultLanguageValue.toLowerCase() === "cash" && setIsLoading(false);
    return data.obj;
  };
  const creatingClues = async () => {
    let body = {
      customerNumber: user?.customerNumber || "",
      type: "Calculator",
      language: lang?.toLowerCase() === "en" ? "en-us" : lang,
      // color: currentColor?.defaultLanguageValue || "",
      engine: currentEngine?.defaultLanguageValue || "",
      duration: Number(currentPeriod?.value) || 0,
      mileage: currentMileage?.value,
      monthlyRate: summaryPrice,
      downPayment: Number(currentDownPayment || showsDownPayment) || 0,
      interestRate: currentloanProduct?.defaultRate,
      loanProduct: currentloanProduct?.loanType
    };
    if (currentLevel === "MEMBERSHIP04" && currentPaymentType.defaultLanguageValue.toLowerCase() !== "loan") {
      return null;
    }
    if (!user && (currentLevel === "MEMBERSHIP03" || currentLevel === "MEMBERSHIP04")) {
      setComparisonToolApiBody(body);
    }
    if (!user || !(currentLevel === "MEMBERSHIP03" || currentLevel === "MEMBERSHIP04")) return null;
    const res = api.caseInfo.comparisonTool(null, body);
    return { res, body };
  };
  //INTEGRATION exampple for tab binding from payment_type route param
  getPaymentTypeData();
  useEffect(() => {
    !isLoading && setIsLoading(true);
    getData();
  }, [currentRouteTabIndex, payment_type, retryCount]);

  const handleResize = useCallback(() => {
    calculateStickyRightPosition();
  }, []);

  const calculateStickyRightPosition = () => {
    const tabElements = document.getElementById("tool-tabs-position");
    setPriceStickyRightPosition(document.body.clientWidth - tabElements.getBoundingClientRect().right);
  };

  useEffect(() => {
    if (sitecoreRoute === match.params.sitecoreRoute) {
      global.addEventListener("resize", handleResize);
      calculateStickyRightPosition();

      /*** fix breadcrumbs */
      let breadcrumbs = [];

      if (route.param_1) {
        const breadCrumbNode1 = {
          breadcrumbName: tabMenuItems[currentRouteTabIndex]?.label,
          url: `/${match.params.lang}${match.params.sitecoreRoute}/l/${route.param_1}`
        };
        breadcrumbs.push(breadCrumbNode1);

        if (route.param_2) {
          const selectedTab = paymentTypeTabs && paymentTypeTabs[0]?.options?.find(x => x.path === route.param_2);

          if (selectedTab) {
            const breadCrumbNode2 = {
              breadcrumbName: selectedTab?.value
            };
            breadcrumbs.push(breadCrumbNode2);
          }
        }
      }

      setDynamicBreadcrumbList(breadcrumbs);
    }

    return () => {
      global.removeEventListener("resize", handleResize, false);
    };
  }, [handleResize, match, paymentTypeTabs, tabMenuItems, tabItems[currentRouteTabIndex]?.items]);

  useEffect(() => {
    return function cleanup() {
      setDynamicBreadcrumbList(null);
    };
  }, []);

  const paymentTypeTabs = tabItems[currentRouteTabIndex]?.items
    ? tabItems[currentRouteTabIndex].items.map(item => {
        if (item.type === "tabs")
          return {
            ...item,
            options: item.options.map((option, index) => {
              return {
                ...option,
                label: option.value || tabs[currentRouteTabIndex].fields.tabs[index]?.fields.label?.value,
                path: tabs[currentRouteTabIndex].fields.tabs?.filter(tabItem => {
                  return tabItem.fields.path?.value.toLowerCase() === paymentTypePath[index] ? tabItem.fields.path?.value : "";
                })[0]?.fields.path?.value,
                onTabClicked: (event, path) => {
                  setRoute({ ...route, param_2: path });
                }
              };
            })
          };
        else return item;
      })
    : undefined;
  const serverError = fields.serverError
    ? {
        heading: fields.serverError.fields.heading.value,
        subheading: fields.serverError.fields.subheading.value,
        infoMessage: {
          html: fields.serverError.fields.infoMessage.value
        },
        showIcon: fields.serverError.fields.showIcon.value,
        linkRetry: {
          buttonText: fields.serverError.fields.linkRetry.fields.buttonText.value,
          callback: () => setRetryCount(retryCount + 1)
        },
        linkAway: fields.serverError.fields.link.fields
      }
    : undefined;
  if (sitecoreRoute === match.params.sitecoreRoute)
    return (
      <div className="calculation-tool" datasourceid={rendering.dataSource}>
        {imageBanner && <ImageBanner {...imageBanner} />}
        {tabMenuItems.length > 0 && <CalculationToolTabs match={match} tabs={tabMenuItems} selectedIndex={currentRouteTabIndex} />}
        <div className="content-container">
          <div className="tab-content">
            {tabItems[currentRouteTabIndex] && (
              <>
                <ToolSection
                  {...{
                    ...tabItems[currentRouteTabIndex],
                    match: match,
                    items: serverResponseStatus === 200 ? paymentTypeTabs : [],
                    serverResonseStatus: serverResponseStatus,
                    serverResponseErrorMsg: serverResponseErrorMsg,
                    dictionary: dictionaryObject,
                    isLoading: isLoading,
                    lang,
                    isSpecialFormat: currentPaymentType.defaultLanguageValue.toLowerCase() === "loan"
                  }}
                />
                {serverResponseStatus !== 200 && fields.serverError && <ServerError {...serverError} />}
              </>
            )}
            {isGlobalLoading && <LoadingSpinner />}
            {serverResponseStatus === 200 && mergedSummary && (
              <>
                {mergedSummary.price && (
                  <MobilePriceBanner
                    {...{
                      ...mergedSummary.price,
                      showInSameFontSize: mergedSummary.showInSameFontSize,
                      showFootnote: mergedSummary.showFootnote,
                      footnoteSymbol: mergedSummary.footnoteSymbol,
                      showYourPrice: mergedSummary.showYourPrice,
                      italianDiscalimerPrice: mergedSummary.italianDiscalimerPrice
                    }}
                  />
                )}

                <CalculationToolSummary
                  {...{
                    ...mergedSummary,
                    dictionary: dictionaryObject,
                    match: match
                  }}
                />
              </>
            )}
          </div>

          <div className="price-container" style={{ right: `${priceStickyRightPosition}px` }}>
            {mergedSummary?.price && (
              <div className="price">
                {mergedSummary.showYourPrice?.value && (
                  <>
                    {mergedSummary.price.tag && <div className="tag">{mergedSummary.price.tag}</div>}
                    {mergedSummary.price.value && (
                      <div className={classNames("value", { "same-size": mergedSummary.showInSameFontSize?.value })}>
                        {mergedSummary.price.value}
                        {mergedSummary.italianDiscalimerPrice && (
                          <>
                            <br /> {mergedSummary.italianDiscalimerPrice}
                          </>
                        )}
                        {mergedSummary.showFootnote?.value && <span className="footnote">{mergedSummary.footnoteSymbol?.value}</span>}
                      </div>
                    )}
                  </>
                )}
                {mergedSummary.price.cta && (
                  <PrimaryLink
                    {...{
                      ...mergedSummary.price.cta,
                      colorScheme: mergedSummary.price.cta.colorScheme || "green"
                    }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  else return null;
};

CalculationTool.propTypes = {
  match: PropTypes.object,
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    tabs: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        path: PropTypes.string
      })
    )
  })
};
const mapStateToProps = state => ({
  user: selectUserState(state)
});
const mapDispatchToProps = dispatch => ({
  setCalculationPrice: data => {
    dispatch(calculationPrice(data));
  },
  setComparisonToolApiBody: data => {
    dispatch(comparisonToolApiBody(data));
  },
  setDynamicBreadcrumbList: breadcrumbList => {
    dispatch(setDynamicBreadcrumbList(breadcrumbList));
  }
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CalculationTool));
